import type { DesignDefinition } from '../types';

const easeOut = [0.22, 1, 0.36, 1] as const;

/** E · Soft Studio: headlines de-blur, cards rise softly, the glass card floats and glows breathe. */
export const studio: DesignDefinition = {
  id: 'studio',
  name: 'Soft Studio',
  nameZh: '柔光工作室',
  description: 'Pillowy cards, rounded type and plum velvet',
  descriptionZh: '柔软卡片、圆润字体与梅紫丝绒',
  swatches: ['#6B3C8E', '#8CCFCF', '#FF8A5B'],
  preview: {
    canvas: '#F4F3F7',
    ink: '#1C1830',
    font: '"Nunito Variable", "Arial Rounded MT Bold", system-ui, sans-serif',
  },
  motion: {
    reveal: { transition: { duration: 0.9, ease: easeOut } },
    heading: { duration: 1.1, ease: easeOut },
    clip: { duration: 1, ease: easeOut },
    stagger: 0.07,
    hover: { y: -6, rotate: 0, transition: { type: 'spring', stiffness: 260, damping: 22 } },
    float: { y: -10, duration: 6 },
    layout: { duration: 0.5, ease: easeOut },
  },
};
